import { Stack, Typography } from '@mui/material';
import useTranslation, { Translation } from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';

type OriginVariant = 'user' | 'group';

interface OriginColumnHeaderProps {
  variant?: OriginVariant;
}

interface OriginTooltipEntry {
  label: string;
  description: string;
}

const getOriginTooltipEntries = (variant: OriginVariant, translation: Translation): OriginTooltipEntry[] => {
  if (variant === 'group') {
    return [
      {
        label: translation.entra_id,
        description: translation.group_was_provisioned_through_entra_and_can_only_be_managed_there
      },
      {
        label: translation.atlas,
        description: translation.group_was_manually_added_and_can_be_fully_edited
      },
      {
        label: translation.preset,
        description: translation.group_is_a_preset_and_has_limited_editing_capabilities
      }
    ];
  }
  return [
    {
      label: translation.entra_id,
      description: translation.user_was_provisioned_through_entra_and_can_only_be_edited_there
    },
    {
      label: translation.atlas,
      description: translation.user_was_manually_added_and_can_be_fully_edited
    },
    {
      label: translation.key_sharing,
      description: translation.user_was_added_by_a_key_manager_and_can_be_edited
    }
  ];
};

export const OriginColumnHeader: React.FC<OriginColumnHeaderProps> = ({ variant = 'user' }) => {
  const { translation } = useTranslation();
  const entries = getOriginTooltipEntries(variant, translation);
  return (
    <ColumnHeaderWithTooltip
      label={translation.origin}
      tooltip={
        <Stack spacing={1}>
          {entries.map((entry) => (
            <Stack key={entry.label}>
              <Typography variant="caption">
                <strong>{entry.label}:</strong>
              </Typography>
              <Typography variant="caption">{entry.description}</Typography>
            </Stack>
          ))}
        </Stack>
      }
    />
  );
};
